import { render, staticRenderFns } from "./BaskoBoxTimeslot.vue?vue&type=template&id=34cf48dc&"
import script from "./BaskoBoxTimeslot.vue?vue&type=script&lang=js&"
export * from "./BaskoBoxTimeslot.vue?vue&type=script&lang=js&"
import style0 from "./BaskoBoxTimeslot.vue?vue&type=style&index=0&id=34cf48dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports